<div class="modal-overlay" *ngIf="isOpen" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Uploading overlay -->
    <div *ngIf="isUploading" class="uploading-overlay">
      <div class="uploading-content">
        <app-spinner [display]="true" [diameter]="48" aria-label="Uploading"></app-spinner>
        <span class="uploading-text">Uploading document…</span>
      </div>
    </div>

    <div class="modal-header">
      <h2 class="modal-title">Document Upload</h2>
      <button class="close-button" (click)="onCancel()" aria-label="Close modal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="modal-content overlay-scroll--custom" scrollActivity [scrollActivityCustom]="true">
      <div class="modal-content-inner">
        <p class="modal-description">Please upload the file for the necessary document update.</p>

        <div class="upload-wrapper">
          <div
            class="upload-zone"
            [class.upload-zone--dragging]="isDragging"
            [class.upload-zone--error]="errorMessage"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInput.click()"
          >
            <span class="material-symbols-outlined upload-icon">upload_file</span>
            <p class="upload-text">
              Drag and drop file here or
              <label class="file-label" (click)="$event.stopPropagation()">
                <span class="choose-file-text">Choose File</span>
                <input
                  #fileInput
                  tabindex="0"
                  type="file"
                  class="file-input"
                  accept=".docx,.xlsx"
                  (change)="onFileSelected($event)"
                />
              </label>
            </p>
          </div>

          <div class="error-message" *ngIf="errorMessage">
            <span class="material-symbols-outlined">error</span>
            <span>{{ errorMessage }}</span>
          </div>

          <div class="selected-file" *ngIf="selectedFile && !errorMessage">
            <div class="file-info">
              <span class="material-symbols-outlined file-icon">description</span>
              <div class="file-details">
                <span class="file-name">{{ selectedFileName }}</span>
                <span class="file-size">{{ selectedFileSize }}</span>
              </div>
            </div>
            <button class="remove-file-btn" (click)="removeFile()" type="button">
              <span class="material-symbols-outlined">close</span>
            </button>
          </div>

          <div class="upload-info">
            <span class="upload-info-text">Supported formats: .docx, .xlsx</span>
            <span class="upload-info-text">Maximum size: 10MB</span>
          </div>
        </div>

        <div class="form-group">
          <app-az-selector
            [label]="'Uploaded File'"
            [options]="documentTypes"
            [selectedValue]="selectedDocumentType"
            (selectionChange)="onDocumentTypeChange($event)"
          ></app-az-selector>
        </div>

        <div class="form-group">
          <label class="form-label">Comments:</label>
          <textarea class="form-textarea" [(ngModel)]="comments" rows="4"></textarea>
        </div>

        <div class="modal-actions">
          <app-az-button
            [label]="'Cancel Upload'"
            [showIcon]="false"
            (click)="onCancel()"
            variant="default"
            [disabled]="isUploading"
          ></app-az-button>
          <app-az-button
            [label]="'Confirm Upload'"
            [showIcon]="false"
            (click)="onConfirm()"
            variant="primary"
            [disabled]="!selectedFile || !selectedDocumentType || isUploading"
          ></app-az-button>
        </div>
      </div>
    </div>
  </div>
</div>
